/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Group_To_See_UsersInputs */



/**
* | output |
* | --- |
* | "Select a group to see users" |
*
* @param {Select_Group_To_See_UsersInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const select_group_to_see_users = /** @type {((inputs?: Select_Group_To_See_UsersInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Group_To_See_UsersInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select a group to see users")
	return /** @type {LocalizedString} */ ("Sélectionner un groupe pour voir les utilisateurs")
});